up.compiler('button[delete]', (element) => {
  const form = element.closest('form')
  up.on(form, 'submit', (evnt) => {
    const confirmed = confirm('Wirklich löschen?')
    if (!confirmed) {
      evnt.preventDefault()
    }
  })
})